module.exports = __webpack_public_path__ + "img/IT0000014665564.580dbc04.svg";